const ITEMS = [
  "DOKUMENTATION",
  "EINSATZUNTERSTÜTZUNG",
  "DROHNENSERVICE",
  "LAGEBILD",
  "INSPEKTION",
  "ORTHOFOTO",
  "SCHADENSBERICHT",
  "KUNDENPORTAL",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="marquee-strip"
      className="relative overflow-hidden border-y border-white/10 bg-[#0D0D0F] py-5"
    >
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center font-display text-xl font-black uppercase tracking-tight text-white/70 lg:text-2xl"
              >
                <span className="px-8">{item}</span>
                <span className="h-2 w-2 rotate-45 bg-[#F5B301]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
